/*
 *
 * LeadsPage constants
 *
 */

export const DOWNLOAD_LEADS_REQUEST     = 'src/LeadsPage/DOWNLOAD_LEADS_REQUEST';
export const DOWNLOAD_LEADS_SUCCESS     = 'src/LeadsPage/DOWNLOAD_LEADS_SUCCESS';
export const DOWNLOAD_LEADS_FAIL        = 'src/LeadsPage/DOWNLOAD_LEADS_FAIL';
export const FETCH_LEADS_REQUEST        = 'src/LeadsPage/FETCH_LEADS_REQUEST';
export const FETCH_LEADS_SUCCESS        = 'src/LeadsPage/FETCH_LEADS_SUCCESS';
export const FETCH_LEADS_FAIL           = 'src/LeadsPage/FETCH_LEADS_FAIL';




// WEBPACK FOOTER //
// ./src/containers/LeadsPage/constants.js